import { render } from "./Car.vue?vue&type=template&id=6785588a&scoped=true"
import script from "./Car.vue?vue&type=script&lang=js"
export * from "./Car.vue?vue&type=script&lang=js"

import "./Car.vue?vue&type=style&index=0&id=6785588a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6785588a"],['__file',"src/views/v2/Car.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6785588a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6785588a', __exports__)) {
    api.reload('6785588a', __exports__)
  }
  
  module.hot.accept("./Car.vue?vue&type=template&id=6785588a&scoped=true", () => {
    api.rerender('6785588a', render)
  })

}


export default __exports__